import { StatAction } from '@/Enum/index';
import { sendStat } from './tools';

export const sendShowStat = (id: string, logmap?: Record<string, unknown>) => {
    sendStat({
        id,
        action: StatAction.SHOW,
        logmap,
    });
};

export const sendClickStat = (id: string, logmap?: Record<string, unknown>) => {
    sendStat({
        id,
        action: StatAction.CLICK,
        logmap,
    });
};
